import { createQueryKeys } from "@lukemorales/query-key-factory";
import { ExciseStampRequestListPayload } from "./exciseStamps.types";

/**
 * Keys used to invalidate stored cached data regarding excise stamp module
 */
export const exciseStampKeys = createQueryKeys("excise_stamps", {
  exciseStampRequestList: ({
    filters,
  }: {
    filters: Partial<ExciseStampRequestListPayload>;
  }) => ({
    queryKey: ["excise_stamp_request_list", filters],
  }),
});
